import { configureStore } from "@reduxjs/toolkit";
import { UIReducer } from "./slices/UI";

export const store = configureStore({
  reducer: {
    UI: UIReducer,
  },
});
